import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Switch } from 'react-router';

import Brand from 'models/brand';
import User from 'models/user';

import { routerLocationShape } from 'lib/common/prop-types';

import AccountHeader from 'components/account/header';
import AccountNavigation from 'components/account/navigation';

import AccountSettings from 'containers/account/settings';
import Bookings from 'containers/account/bookings';
import PaymentMethods from 'containers/account/payment-methods';
import Vehicles from 'containers/account/saved-vehicles';

import handleEnterpriseInvite from 'action-creators/account/handle-enterprise-invite';
import initializeAccountSettings from 'action-creators/account/initialize-account-settings';
import initializeBookings from 'action-creators/bookings/initialize-bookings';
import initializePaymentMethods from 'action-creators/account/initialize-payment-methods';
import initializeVehicles from 'action-creators/account/initialize-vehicles';
import trackEvent from 'action-creators/analytics/track-event';

const propTypes = {
  app: PropTypes.string.isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  enterpriseInvite: PropTypes.instanceOf(Map),
  handleEnterpriseInvite: PropTypes.func.isRequired,
  initializeAccountSettings: PropTypes.func.isRequired,
  initializeBookings: PropTypes.func.isRequired,
  initializePaymentMethods: PropTypes.func.isRequired,
  initializeVehicles: PropTypes.func.isRequired,
  routerLocation: routerLocationShape.isRequired,
  trackEvent: PropTypes.func.isRequired,
  user: PropTypes.instanceOf(User).isRequired,
};

const defaultProps = {
  enterpriseInvite: null,
};

class Account extends Component {
  constructor(props) {
    super(props);
    if (props.enterpriseInvite && props.user) {
      this.props.handleEnterpriseInvite();
    }
  }

  render() {
    const {
      brand,
      user,
      app,
      routerLocation,
    } = this.props;

    return (
      <div className="generic-page">
        <AccountHeader app={app} brand={brand} />
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4 hidden-lte-sm">
              <AccountNavigation
                brand={brand}
                user={user}
                app={app}
                trackEvent={this.props.trackEvent}
              />
            </div>
            <div className="col-lg-9 col-md-8 col-xs-12">
              <Switch location={routerLocation}>
                <Route
                  path="/account/settings"
                  render={() => {
                    this.props.initializeAccountSettings();
                    return <AccountSettings />;
                  }}
                />
                <Route
                  path="/account/payment-methods"
                  render={() => {
                    this.props.initializePaymentMethods();
                    return <PaymentMethods />;
                  }}
                />
                <Route
                  path="/account/vehicles"
                  render={() => {
                    this.props.initializeVehicles();
                    return <Vehicles />;
                  }}
                />
                <Route
                  path="/account"
                  exact
                  render={() => {
                    this.props.initializeBookings();
                    return <Bookings />;
                  }}
                />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  app: state.app.name,
  appContext: state.app.appContext,
  brand: state.brand.brand,
  user: state.account.user,
  enterpriseInvite: state.account.enterpriseInvite,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    initializeBookings,
    initializeVehicles,
    initializePaymentMethods,
    initializeAccountSettings,
    handleEnterpriseInvite,
    trackEvent,
  }, dispatch)
);

Account.propTypes = propTypes;
Account.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(Account);
